// After doing any changes please keep sync this duplicate files in GENTING_APP_HTML and PHTOALBUM projects
// NOTE: shopify docs https://shopify.github.io/js-buy-sdk/, https://shopify.dev/docs/api/storefront

function ShopifyUtil() {
  const self = this;
  this.PRODUCT_OPTION_POOL_PREFIX = 'pool_prefix';
  this.PRODUCT_OPTION_IS_VIP = 'is_vip';
  // TODO get those values from event opts field

  const shopifyDomain = localStorage.getItem('shopDomain'); // 'storibox.myshopify.com';
  const shopifyAccessToken = localStorage.getItem('shopToken'); // '9b8becdb1a16e0e9b88c1299e756d9d0';
  const shippingAddress = localStorage.getItem('shippingAddress');

  const client = window.ShopifyBuy.buildClient({
    domain: shopifyDomain,
    storefrontAccessToken: shopifyAccessToken,
  });

  const localStorageCheckoutIdKey = 'occo-shopify-checkout-id-key';
  const localStorageCheckoutUrlKey = 'occo-shopify-checkout-url-key';

  this.getCheckout = function (callback, attempt = 5) {
    if (attempt <= 0) return;

    const checkoutId = localStorage.getItem(localStorageCheckoutIdKey);
    if (checkoutId) {
      client.checkout
        .fetch(checkoutId)
        .then((checkout) => {
          if (!checkout || checkout.completedAt) {
            return self.createCheckout(callback);
          }
          if (checkout.ready) {
            console.log('checkout ready', checkout);
            return callback(checkout);
          }
          console.log('checkout is not ready');
          setTimeout(() => {
            self.getCheckout(callback, attempt - 1);
          }, 500);
        })
        .catch((err) => {
          console.error(err);
          self.createCheckout(callback);
        });
    } else {
      self.createCheckout(callback);
    }
  };

  this.createCheckout = function (callback) {
    console.log('shippingAddress', shippingAddress);
    client.checkout.create(getParams()).then((checkout) => {
      localStorage.setItem(localStorageCheckoutIdKey, checkout.id);
      localStorage.setItem(localStorageCheckoutUrlKey, checkout.webUrl);
      callback(checkout);
    });

    function getParams() {
      if (
        !shippingAddress ||
        shippingAddress === 'null' ||
        shippingAddress === 'undefined' ||
        shippingAddress.length < 50
      )
        return;

      const shippAddresObj = JSON.parse(shippingAddress);
      return {
        shippingAddress: {
          address1: shippAddresObj.shopifyAddress1,
          address2: shippAddresObj.shopifyAddress2,
          city: shippAddresObj.shopifyCity,
          company: shippAddresObj.shopifyCompany,
          country: shippAddresObj.shopifyCountry,
          firstName: shippAddresObj.shopifyFirstName,
          lastName: shippAddresObj.shopifyLastName,
          phone: shippAddresObj.shopifyPhoneNumber,
          province: shippAddresObj.shopifyState,
          zip: shippAddresObj.shopifyZip,
        },
      };
    }
  };

  this.getCollection = function (collectionId) {
    return new Promise((resolve, reject) => {
      const cId = self.normalizeCollectionId(collectionId);
      client.collection
        .fetchWithProducts(cId, {
          productsFirst: 20,
        })
        .then((collection) => resolve(collection))
        .catch((err) => {
          console.error(err);
          return reject(err);
        });
    });
  };

  this.applyDiscount = function (checkoutId, discountCode, callback) {
    client.checkout.addDiscount(checkoutId, discountCode).then(() => {
      self.getCheckout(callback);
    });
  };

  this.addLineItems = function (checkoutId, lineItems) {
    return new Promise((resolve, reject) => {
      if (lineItems && lineItems.length > 0) {
        for (const lineItem of lineItems) {
          if (lineItem) {
            // eslint-disable-next-line no-prototype-builtins
            if (lineItem.hasOwnProperty('attendeeUid')) {
              if (lineItem.attendeeUid === 'false' || lineItem.attendeeUid === false) {
                Sentry.captureMessage(`Attendee UId equal "${lineItem.attendeeUid}"`, 'error');
              }
            }
            let foundAtt = false;
            if (lineItem.customAttributes && lineItem.customAttributes.length > 0) {
              for (const customAtt of lineItem.customAttributes) {
                if (customAtt.key === '_c') {
                  customAtt.value = new Date();
                  foundAtt = true;
                  break;
                }
              }
            }
            if (!foundAtt) {
              lineItem.customAttributes.push({
                key: '_c',
                value: new Date(),
              });
            }
          }
        }
      }
      client.checkout
        .addLineItems(checkoutId, lineItems)
        .then(() => self.getCheckout(resolve))
        .catch((err) => {
          console.error(err);
          return reject(err);
        });
    });
  };

  this.updateLineItems = function (checkoutId, lineItems) {
    return new Promise((resolve, reject) => {
      client.checkout
        .updateLineItems(checkoutId, lineItems)
        .then(() => self.getCheckout(resolve))
        .catch((err) => {
          console.error(err);
          return reject(err);
        });
    });
  };

  this.getProduct = function (productId) {
    return new Promise((resolve, reject) => {
      const pUid = self.normalizeProductId(productId);
      client.product
        .fetch(pUid)
        .then((product) => resolve(product))
        .catch((err) => {
          console.error(err);
          return reject(err);
        });
    });
  };

  this.cleanCheckout = function () {
    return new Promise((resolve, reject) => {
      const checkoutId = localStorage.getItem(localStorageCheckoutIdKey);
      if (checkoutId) {
        client.checkout
          .fetch(checkoutId)
          .then((checkout) => {
            if (!checkout || !checkout.lineItems || checkout.lineItems.length < 1) {
              return resolve();
            }
            const { lineItems } = checkout;
            const newLineItems = [];
            for (const oldLineItem of lineItems) {
              const lineItem = {
                id: oldLineItem.id,
                quantity: 0,
              };
              newLineItems.push(lineItem);
            }
            self
              .updateLineItems(checkoutId, newLineItems)
              .then(() => self.getCheckout(resolve))
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      } else {
        resolve();
      }
    });
  };

  this.getCollectionALaCarteVariantArray = function (collectionId, isVip) {
    return new Promise((resolve, reject) => {
      shopifyUtil
        .getCollection(collectionId)
        .then((collection) => {
          const variantArr = [];
          const { products } = collection;
          for (const product of products) {
            let variant = self.getProductVariant(product, isVip);
            if (variant == null) {
              variant = product.variants[0];
            }
            const poolPrefix = shopifyUtil.getVariantSelectedOption(variant, shopifyUtil.PRODUCT_OPTION_POOL_PREFIX);
            variant.productTitle = product.title;
            variant.poolPrefix = poolPrefix;
            variant.desc = product.description;
            variant.shipmentPoolPrefix = getShipmentPoolPrefixFromDescription(product.description);
            variantArr.push(variant);
          }
          return resolve(variantArr);
        })
        .catch((err) => reject(err));
    });
  };

  function getShipmentPoolPrefixFromDescription(description) {
    let shipPoolPrefix = null;
    if (!description) {
      return null;
    }
    try {
      const descr = JSON.parse(description);
      if (descr && descr.shipment_pool_prefix) {
        shipPoolPrefix = descr.shipment_pool_prefix;
      }
    } catch (err) {
      console.log(err);
      return null;
    }
    return shipPoolPrefix;
  }

  function getResortDescriptionData(product) {
    if (!product.description) {
      return null;
    }
    const resortDescriptionData = {};
    try {
      // { "key_type": "resort", "fee_persent": 6 }
      const descr = JSON.parse(product.description);
      if (descr && descr.product_type === 'resort_fee') {
        resortDescriptionData.isResortFee = true;
        if (descr.fee_persent) resortDescriptionData.fee_persent = descr.fee_persent;
        else return null;
      } else {
        return null;
      }
    } catch (err) {
      console.log(err);
      return null;
    }
    return resortDescriptionData;
  }

  this.getCollVariant = function (collectionId, isVip) {
    return new Promise((resolve, reject) => {
      shopifyUtil
        .getCollection(collectionId)
        .then((collection) => {
          const description = collection.description ? collection.description : '{}';
          // {"product_list":{"6750600167632": 3}, "pack_product" : "6878987550928" }
          const collObj = JSON.parse(description);
          const prodCount = collObj.product_list;
          const packProductId = collObj.pack_product;
          self
            .getProduct(packProductId)
            .then((packProd) => {
              const variantProdPack = self.getProductVariant(packProd, isVip);

              const prodIdArray = Object.keys(prodCount);
              const newProdCount = {};
              for (const pId of prodIdArray) {
                newProdCount[shopifyUtil.normalizeProductId(pId)] = prodCount[pId];
              }
              const variantArr = [];
              const { products } = collection;
              let productGroup = 0;
              for (const product of products) {
                productGroup += 1;
                const resortFeeData = getResortDescriptionData(product);
                let variant = self.getProductVariant(product, isVip);
                if (variant == null) {
                  variant = product.variants[0];
                }
                const poolPrefix = shopifyUtil.getVariantSelectedOption(
                  variant,
                  shopifyUtil.PRODUCT_OPTION_POOL_PREFIX
                );
                const shipmentPoolPrefix = getShipmentPoolPrefixFromDescription(product.description);

                if (newProdCount[product.id]) {
                  for (let i = 0; i < newProdCount[product.id]; i += 1) {
                    variantArr.push({
                      productTitle: product.title,
                      id: variant.id,
                      pid: `${productGroup}_${i}`,
                      desc: product.description,
                      imgUrl: variant.image.src,
                      poolPrefix,
                      shipmentPoolPrefix,
                    });
                  }
                } else {
                  const newVariant = {};
                  if (resortFeeData) {
                    let fee = (packProd.variants[isVip].priceV2.amount * resortFeeData.fee_persent) / 100;
                    fee = Math.round(fee * 100) / 100;
                    const ttl = `${product.title} ( ${resortFeeData.fee_persent}% included ) - ${packProd.variants[isVip].priceV2.currencyCode}${fee}`;
                    newVariant.productTitle = ttl;
                    newVariant.isResortFee = true;
                  } else {
                    newVariant.productTitle = product.title;
                  }
                  newVariant.id = variant.id;
                  newVariant.pid = `${productGroup}_${0}`;
                  newVariant.desc = product.description;
                  newVariant.imgUrl = variant.image.src;
                  newVariant.poolPrefix = poolPrefix;
                  newVariant.shipmentPoolPrefix = shipmentPoolPrefix;
                  variantArr.push(newVariant);
                }
              }
              variantProdPack.variantArr = variantArr;
              return resolve(variantProdPack);
            })
            .catch((err) => reject(err));
        })
        .catch((err) => reject(err));
    });
  };

  this.getProductVariant = function (product, isVip) {
    const prodVariantList = product.variants;
    if (!prodVariantList || prodVariantList.length < 1) {
      return null;
    }
    for (const prodVariant of prodVariantList) {
      const variantIsVipValue = self.getVariantSelectedOption(prodVariant, self.PRODUCT_OPTION_IS_VIP);
      if (isVip == null || isVip === '' || isVip === variantIsVipValue || prodVariantList.length === 1) {
        return prodVariant;
      }
    }
    return null;
  };

  this.getVariantSelectedOption = function (prodVariant, optionName) {
    const { selectedOptions } = prodVariant;
    if (!selectedOptions || selectedOptions.length < 1) {
      return null;
    }
    for (const selectedOption of selectedOptions) {
      if (selectedOption.name === optionName) {
        return selectedOption.value;
      }
    }
    return null;
  };

  this.normalizeProductId = function (id) {
    return normalizeId('Product', id);
  };

  this.normalizeCollectionId = function (id) {
    return normalizeId('Collection', id);
  };

  this.normalizeProductVariantId = function (id) {
    return normalizeId('ProductVariant', id);
  };

  function normalizeId(type, databaseKey) {
    return `gid://shopify/${type}/${databaseKey}`; // btoa(`gid://shopify/${type}/${databaseKey}`); now product id from shopify is not encoded
  }
}
export const shopifyUtil = new ShopifyUtil();
